import { useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { Container, Header, Button, Segment } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';

const FileView = (props) => {
  const { content } = props;
  const token = useSelector((state) => state.userSession.token);

  const downloadUrl = flattenToAppURL(content.file?.download);
  const contentType = content.file?.['content-type'];
  const isPdf = contentType === 'application/pdf';

  // Decide whether to rewrite @@download → @@display-file
  const getDisplayUrl = (url, type) => {
    if (type === 'application/pdf') {
      return url.replace('@@download', '@@display-file');
    }
    // For videos (mp4) and everything else, stick with @@download/file
    return url;
  };

  const displayUrl = getDisplayUrl(downloadUrl, contentType);

  // Auto redirect for PDFs if not authenticated
  useEffect(() => {
    if (isPdf && !token) {
      window.location.replace(displayUrl);
    }
  }, [isPdf, displayUrl, token]);

  const renderFileContent = () => {
    if (isPdf && token) {
      return (
        <Button
          as="a"
          href={displayUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          View PDF
        </Button>
      );
    } else {
      return (
        <Button
          as="a"
          href={displayUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Download File
        </Button>
      );
    }
  };

  if (isPdf && token) {
    return (
      <Container id="view-wrapper file-view">
        <h1 className="documentFirstHeading">{content.title}</h1>
        {content.description && (
          <p className="documentDescription">{content.description}</p>
        )}
        <Segment>
          <Header as="h2">File Content</Header>
          {renderFileContent()}
        </Segment>
        <Segment>
          <Header as="h3">File Details</Header>
          <p>File Type: {contentType}</p>
          <p>File Size: {content.file?.size} bytes</p>
        </Segment>
      </Container>
    );
  } else {
    return (
      <Container id="view-wrapper file-view">
        <h1 className="documentFirstHeading">{content.title}</h1>
        {content.description && (
          <p className="documentDescription">{content.description}</p>
        )}
        <Segment>
          <Header as="h2">File</Header>
          {renderFileContent()}
        </Segment>
      </Container>
    );
  }
};

export default FileView;
    
